export default {
  title: 'Calendar integration',
  notConfigured:
    'Microsoft calendar integration is not configured for this organization.',
  queryError: 'Error loading calendar integration data.',
  loadingStatus: 'Loading Microsoft integration status',
  loadingMappings: 'Loading calendar integration data',
  status: {
    title: 'Microsoft integration status',
    PENDING: 'Pending',
    ACTIVE: 'Active',
    FAILED: 'Failed',
    DISABLED: 'Disabled',
  },
  add: {
    title: 'Add room mapping',
    spaceLabel: 'Lockspace space',
    roomLabel: 'Exchange room',
    button: 'Add mapping',
  },
  mappings: {
    title: 'Room mappings',
    empty: 'No room mappings have been added yet.',
    removeLabel: 'Remove mapping',
    columns: {
      space: 'Lockspace space',
      room: 'Exchange room',
      status: 'Status',
      actions: 'Actions',
    },
  },
  removeDialog: {
    title: 'Remove room mapping?',
    description: 'Calendar synchronization will be disabled for {{spaceName}}.',
    confirm: 'Remove mapping',
  },
  toast: {
    addSuccess: 'Room mapping added successfully.',
    removeSuccess: 'Room mapping removed successfully.',
    spaceHasBookings:
      'This space has future Lockspace bookings and cannot be mapped yet.',
    roomNotEmpty:
      'This Exchange room has future calendar events and cannot be mapped yet.',
    roomUnavailable: 'The selected Exchange room is unavailable or invalid.',
  },
};
